import { AdminBottomNav } from '@/components/admin/admin-bottom-nav';
import { AppContent } from '@/components/app-content';
import { AppShell } from '@/components/app-shell';
import { AppSidebar } from '@/components/app-sidebar';
import { AppSidebarHeader } from '@/components/app-sidebar-header';
import type { AppLayoutProps } from '@/types';

export default function AppSidebarLayout({
    children,
    breadcrumbs = [],
}: AppLayoutProps) {
    return (
        <AppShell variant="sidebar" className="bg-[#f8faf9] dark:bg-[#0a1210]">
            <AppSidebar />
            <AppContent variant="sidebar" className="relative overflow-x-hidden">
                <AppSidebarHeader breadcrumbs={breadcrumbs} />
                <main className="px-4 py-5 pb-24 md:px-8 md:py-8 md:pb-8">{children}</main>
                <AdminBottomNav />
            </AppContent>
        </AppShell>
    );
}
